import { FishingReport, WaterbodyDetail } from '@omniafishing/core';
import React, { useState } from 'react';
import { useFishingReportListViewed } from '../../../../hooks/use_fishing_report_list_viewed';
import { useResponsive } from '../../../../hooks/use_responsive';
import { LINE_ATTRIBUTION } from '../../../../redux/cart';
import { FishingReportCard } from '../../../fishing_report_card/fishing_report_card';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import { Spacer } from '../../../spacer/spacer';
import { NUMBER_OF_REPORTS_TO_INCREMENT } from './waterbody_detail_fishing_reports_overview';
import styles from './waterbody_detail_fishing_reports_overview.less';

interface WaterbodyDetailNearbyFishingReportsProps {
  nearbyReports: FishingReport[];
  waterbody: WaterbodyDetail;
  sortedByNewest: boolean;
}

export const WaterbodyDetailNearbyFishingReports = (
  props: WaterbodyDetailNearbyFishingReportsProps
) => {
  const { nearbyReports, waterbody } = props;

  const [numberOfNearbyReportsToShow, setNumberOfNearbyReportsToShow] = useState(9);
  const nearbyReportsToRender = nearbyReports.slice(0, numberOfNearbyReportsToShow);

  const totalFilteredNearbyReportsCount = nearbyReports.length;
  const showLoadMoreNearbyButton = numberOfNearbyReportsToShow < totalFilteredNearbyReportsCount;

  const showMoreFishingReportsNearby = () => {
    setNumberOfNearbyReportsToShow((num) =>
      Math.min(num + NUMBER_OF_REPORTS_TO_INCREMENT, totalFilteredNearbyReportsCount)
    );
  };

  useFishingReportListViewed(nearbyReportsToRender, 'embedded', 2, nearbyReportsToRender.length);

  const { isSmallDesktop, isMobile } = useResponsive();

  let heroImageWidth: number;

  if (isSmallDesktop) {
    heroImageWidth = 435;
  } else if (!isSmallDesktop && !isMobile) {
    heroImageWidth = 478;
  }

  return (
    <>
      <Spacer size={24} />
      <ul className={styles.frRows}>
        {nearbyReportsToRender.map((report, i) => {
          return (
            <li key={report.id} className={styles.card}>
              <FishingReportCard
                alternateHeroPixelWidth={heroImageWidth}
                className={styles.fishingReportCard}
                fishingReport={report}
                lineItemAttribution={[
                  {
                    key: LINE_ATTRIBUTION.WATERBODY_ID,
                    value: waterbody.id,
                  },
                ]}
                position={i}
                reportedOnBadge
              />
            </li>
          );
        })}
      </ul>
      {showLoadMoreNearbyButton ? (
        <div className={styles.loadMoreButton}>
          <OmniaButton
            size="lg"
            fontSize={14}
            kind="tertiary"
            onPress={showMoreFishingReportsNearby}
          >
            Load More Fishing Reports
          </OmniaButton>
        </div>
      ) : (
        <Spacer size={50} />
      )}
    </>
  );
};
